<template>
  <v-system-bar
    app
    v-bind="systemBarProps"
    style="z-index: 11;"
  >
    <v-spacer />
    <v-tooltip bottom>
      <template #activator="{ on }">
        <v-btn icon v-on="on" @click="toggleFocusMode">
          <!-- Single icon that changes based on focusMode state -->
          <v-icon :color="focusMode ? 'primary' : ''">
            {{ focusMode ? 'mdi-fullscreen-exit' : 'mdi-fullscreen' }}
          </v-icon>
        </v-btn>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
  </v-system-bar>
</template>

<script>
export default {
  name: 'TopHeader',
  props: {
    focusMode: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    systemBarProps () {
      return this.focusMode
        ? { 'lights-out': '' }
        : { color: 'rgba(199, 25, 0, 0.8)', dark: '' };
    },
    tooltipText () {
      return this.focusMode
        ? 'Quitter le mode de mise au point'
        : 'Entrer dans le mode de mise au point';
    }
  },
  methods: {
    toggleFocusMode () {
      this.$emit('toggle-focus-mode');
    }
  }
};
</script>
